/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Subject } from 'rxjs';

export namespace Types {
    export interface HandlerCallbackElement<CallbackType> {
        token: number;
        callback: CallbackType;
    }

    export type HandlerPredicate = (content: string) => boolean;

    export type KeyExtractor<InternalType, KeyType> = (content: InternalType) => KeyType;
    export type ValueExtractor<InternalType, ValueType> = (content: InternalType) => ValueType;
    export type TransformedData<InternalType> = (content: string) => InternalType;

    export interface HandlerMap<KeyType, InternalType, ValueType> {
        [key: string]: {
            // 'IPC_EVENT', 'SIMPLE_WINDOW_EVENT', 'STRUCTURED_WINDOW_EVENT'
            pred: HandlerPredicate;
            keyFunc: KeyExtractor<InternalType, KeyType>;
            valFunc: ValueExtractor<InternalType, ValueType>;
            transformedFunc: TransformedData<InternalType>;
            internalSubjects: Map<KeyType, Subject<ValueType>>;
            persistentInternalSubjects: Map<KeyType, Subject<ValueType>>;
            queuedEvents: string[];
        };
    }

    export enum HandlerEventType {
        SimpleWindowEvent = 'SIMPLE_WINDOW_EVENT',
        StructuredWindowEvent = 'STRUCTURED_WINDOW_EVENT',
        IpcEvent = 'IPC_EVENT'
    }
}
